/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import FileInput, { FileInputProps } from './inputs/FileInput'
import { useIntl } from 'react-intl'
import { Badge, Group, Loader } from '@mantine/core'

export type FileTemplateManagerProps = FileInputProps & {
  description?: string,
  label?: string,
  loading?: boolean,
}

function FileTemplateManager (props: FileTemplateManagerProps) {
  const {
    description,
    disabled,
    label,
    loading,
    onDelete,
    onDownload,
    onUpload,
    value,
    ...others
  } = props

  const intl = useIntl()

  return (
    <FileInput
      {...others}
      description={description}
      disabled={disabled || loading}
      label={<Group>
        {label}
        <Badge
          color={value != null ? 'blue' : 'gray'}
          size="xs"
        >
          {loading
            ? <Loader size="xs" type="dots" color="white" />
            : value != null
              ? intl.formatMessage({
                id: 'customized',
                defaultMessage: 'Personnalisé'
              })
              : intl.formatMessage({
                id: 'by_default',
                defaultMessage: 'Par défaut'
              })
          }
        </Badge>
      </Group>}
      onDelete={onDelete}
      onDownload={onDownload}
      onUpload={onUpload}
      value={value}
    />
  )
}

export default FileTemplateManager
